function collectAllChildren(element) {
  const result = [];
  const queue = [element];
  while (queue.length > 0) {
    const currentElement = queue.shift();
    if (!currentElement) {
      break;
    }
    for (let i = 0; i < currentElement.children.length; i++) {
      const child = currentElement.children[i];
      result.push(child);
      queue.push(child);
    }
  }
  return result;
}
export default function applyColorToSvg(element, color) {
  const elements = [element, ...collectAllChildren(element)];
  elements.forEach(element => {
    const strokeColor = element.getAttribute('stroke');
    const fillColor = element.getAttribute('fill');
    if (strokeColor === '#ff00cb') {
      element.style.stroke = color;
    }
    if (fillColor === '#ff00cb') {
      element.style.fill = color;
    }
    if (strokeColor === '#7B61FF') {
      element.style.stroke = color;
    }
    if (fillColor === '#7B61FF') {
      element.style.fill = color;
    }
  });
}